import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  
  const gifs = [
    process.env.PUBLIC_URL + '/GIFs/Art is Therapy.gif',
    process.env.PUBLIC_URL + '/GIFs/Arts and Craft, Notes, Space.gif',
    process.env.PUBLIC_URL + '/GIFs/To Procrastinate Quote.gif',
    process.env.PUBLIC_URL + '/GIFs/New Project.gif',
    process.env.PUBLIC_URL + '/GIFs/So Many Ideas, So Little Time!.gif',
    process.env.PUBLIC_URL + '/GIFs/Swipe Up.gif',
    process.env.PUBLIC_URL + '/GIFs/Work-In-Progress.gif',
    process.env.PUBLIC_URL + '/GIFs/Make-Create-Express-Destress.gif'
  ];

  const [randomGif, setRandomGif] = useState(null);

  useEffect(() => {
    // Display a random gif while waiting
    const randomIndex = Math.floor(Math.random() * gifs.length);
    setRandomGif(gifs[randomIndex]);

    // Delay the redirection after 1 second
    const timeout = setTimeout(() => {
      // Redirect to the desired URL and replace the current URL in history
      window.location.replace('https://electronote.onrender.com');
    }, 2000);

    // Clean up the timeout when the component unmounts
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="center-container">
      {randomGif && <img src={randomGif} alt="Random Gif" className="centered-gif" />}
      </div>
    </>
  );
}

export default App;
